// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EarningsBreakdown Component Styles */

.earnings-breakdown {
  transition: all 0.3s ease-in-out;
}

.earnings-header {
  -webkit-user-select: none;
          user-select: none;
}

.earnings-header:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.earnings-toggle {
  transition: transform 0.3s ease-in-out, color 0.3s ease-in-out;
  transform: translateY(0);
}

.earnings-header:hover .earnings-toggle {
  transform: translateY(-1px);
}

/* Smooth expansion animation */
.earnings-summary {
  max-height: 0;
  opacity: 0;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.earnings-summary.expanded {
  max-height: 500px;
  opacity: 1;
}

/* Items fade in when expanded */
.earnings-item,
.summary-item {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Color indicators */
.earnings-breakdown .text-red-600 {
  color: #dc2626;
  font-weight: 500;
}

.earnings-breakdown .text-green-600 {
  color: #16a34a;
  font-weight: 500;
}

/* Add-ons section styling */
.addons-section {
  background-color: rgba(22, 163, 74, 0.05);
  padding: 0.75rem;
  border-radius: 0.375rem;
  border-left: 3px solid #16a34a;
}

/* Mobile responsive adjustments */
@media (max-width: 640px) {
  .earnings-header {
    padding: 0.875rem;
  }

  .earnings-main,
  .earnings-summary > div {
    padding: 0.875rem;
  }

  .earnings-item,
  .summary-item {
    font-size: 0.875rem;
  }

  .earnings-total .text-lg {
    font-size: 1.125rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .earnings-breakdown,
  .earnings-toggle,
  .earnings-summary,
  .earnings-item,
  .summary-item {
    animation: none !important;
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Driver/EarningsBreakdown.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8DAA8D;EAC9D,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,UAAU;EACV,iEAAiE;AACnE;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA,gCAAgC;AAChC;;EAEE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE;;;;;IAKE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["/* EarningsBreakdown Component Styles */\n\n.earnings-breakdown {\n  transition: all 0.3s ease-in-out;\n}\n\n.earnings-header {\n  user-select: none;\n}\n\n.earnings-header:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.earnings-toggle {\n  transition: transform 0.3s ease-in-out, color 0.3s ease-in-out;\n  transform: translateY(0);\n}\n\n.earnings-header:hover .earnings-toggle {\n  transform: translateY(-1px);\n}\n\n/* Smooth expansion animation */\n.earnings-summary {\n  max-height: 0;\n  opacity: 0;\n  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n}\n\n.earnings-summary.expanded {\n  max-height: 500px;\n  opacity: 1;\n}\n\n/* Items fade in when expanded */\n.earnings-item,\n.summary-item {\n  animation: fadeInUp 0.3s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Color indicators */\n.earnings-breakdown .text-red-600 {\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.earnings-breakdown .text-green-600 {\n  color: #16a34a;\n  font-weight: 500;\n}\n\n/* Add-ons section styling */\n.addons-section {\n  background-color: rgba(22, 163, 74, 0.05);\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  border-left: 3px solid #16a34a;\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 640px) {\n  .earnings-header {\n    padding: 0.875rem;\n  }\n\n  .earnings-main,\n  .earnings-summary > div {\n    padding: 0.875rem;\n  }\n\n  .earnings-item,\n  .summary-item {\n    font-size: 0.875rem;\n  }\n\n  .earnings-total .text-lg {\n    font-size: 1.125rem;\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .earnings-breakdown,\n  .earnings-toggle,\n  .earnings-summary,\n  .earnings-item,\n  .summary-item {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
